import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin(nuxtApp => {
  const { vueApp } = nuxtApp

  Sentry.init({
    app: [vueApp],
    dsn: 'https://a82bc21052751258eeed20e9116a6c69@o446669.ingest.us.sentry.io/4511105199374336',
    release: nuxtApp.$config.public.globalO7Release,
    environment: nuxtApp.$config.public.sentryEnvironment,
    integrations: [Sentry.browserTracingIntegration({ router: useRouter() })],
    tracesSampleRate: 0.01,
    ignoreErrors: [/ibFindAllVideos/],
    beforeSend(event, hint) {
      if (event.exception) {
        // eslint-disable-next-line no-console
        console.log(`[Exeption handled by Sentry]: (${hint.originalException})`, { event, hint })
      }
      return event
    }
  })

  vueApp.mixin(
    Sentry.createTracingMixins({ trackComponents: true, timeout: 2000, hooks: ['activate', 'mount', 'update'] })
  )
  Sentry.attachErrorHandler(vueApp, {
    logErrors: false,
    attachProps: true,
    trackComponents: true,
    timeout: 2000,
    hooks: ['activate', 'mount', 'update'],
    attachErrorHandler: true
  })

  return {
    provide: {
      sentrySetContext: Sentry.setContext,
      sentrySetUser: Sentry.setUser,
      sentrySetTag: Sentry.setTag,
      sentryAddBreadcrumb: Sentry.addBreadcrumb,
      sentryCaptureException: Sentry.captureException
    }
  }
})
